var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "whole-school-emotion-analysis" },
    [
      _vm._m(0),
      _c("TableList", {
        staticStyle: { width: "100%" },
        attrs: {
          columns: _vm.tableColumns,
          tableData: _vm.tableData,
          loading: _vm.loading,
          scroll: {},
        },
      }),
      _c("div", { staticClass: "trend-analysis" }, [
        _c(
          "div",
          { staticClass: "trend-content" },
          [
            _vm._m(1),
            _c("p", { staticClass: "trend-paragraph" }, [
              _vm._v(
                "\n        本次分析基于" +
                  _vm._s(_vm.dateRangeText) +
                  "所有的学生关爱记录，完成全维度分类统计与深度分析，核心结论如下："
              ),
              _c("br"),
            ]),
            _vm._l(_vm.topThreeList, function (item, index) {
              return _c("p", { key: index, staticClass: "trend-paragraph" }, [
                _vm._v(
                  "\n           " +
                    _vm._s(item.reasonName) +
                    "：占比 " +
                    _vm._s(item.ratio) +
                    "\n      "
                ),
              ])
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "flex-align-center",
        staticStyle: { "margin-bottom": "20px" },
      },
      [
        _c("div", { staticClass: "record-title" }, [
          _vm._v("全校情绪健康特征分析"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "trend-title" }, [
      _c("img", {
        staticStyle: { width: "14px", height: "14px", "margin-right": "5px" },
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/analyse.png"),
          alt: "",
        },
      }),
      _c("span", [_vm._v("趋势分析：")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }